import { useParams } from "react-router-dom";
import CatastroLanding from "./CatastroLanding";
import FichaCatastral from "./FichaCatastral";
import TablaPVT from "./TablaPVT";
import TablaTVC from "./TablaTVC";
import TablaDepreciacion from "./TablaDepreciacion";
import ClasificadorInmuebles from "./ClasificadorInmuebles";
import SolvenciaInmobiliaria from "./SolvenciaInmobiliaria";
import BoletinCalculo from "./BoletinCalculo";
import ExpedienteDigital from "./ExpedienteDigital";
import Mapeo from "./Mapeo";

const CatastroPage = () => {
  const { submodulo } = useParams();

  if (submodulo === "ficha-catastral") return <FichaCatastral />;
  if (submodulo === "tabla-pvt") return <TablaPVT />;
  if (submodulo === "tabla-tvc") return <TablaTVC />;
  if (submodulo === "tabla-depreciacion") return <TablaDepreciacion />;
  if (submodulo === "clasificador-inmuebles") return <ClasificadorInmuebles />;
  if (submodulo === "solvencia") return <SolvenciaInmobiliaria />;
  if (submodulo === "boletin-calculo") return <BoletinCalculo />;
  if (submodulo === "expediente-digital") return <ExpedienteDigital />;
  if (submodulo === "mapeo") return <Mapeo />;

  return <CatastroLanding />;
};

export default CatastroPage;
